import React from "react";
import "./style.less";
import { FaBuilding } from "react-icons/fa";
import { authContext } from "../../configurations/adalConfig";
import { NavLink } from "react-router-dom";
import { Button, TextField } from "@material-ui/core";
import { ShowToast, toastType } from "../../utils/toast-service";
import { API_URL } from "../../constants/api";
import { apiPost } from "../../utils/api_service";
import { IsSectionVisible } from "../../utils/helper";
import { SECTIONS } from "../../constants/appConstants";

export default class ErrorPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      comments: "",
      errorCode: props.details.code,
      heading: props.details.heading,
      message: props.details.message,
      goToHomeEnabled: props.details.goToHomeEnabled,
      emailId: props.emailId != undefined ? props.emailId : "",
      isUnauthorized:
        props.isUnauthorized != undefined ? props.isUnauthorized : false,
    };
  }
  componentDidMount = () => {};

  /** Send invitation email */
  sendInvitationEmail = () => {
    let postBody = {};
    if (this.state.emailId && this.state.emailId.length > 0) {
      postBody = {
        EmailId: this.state.emailId,
        comment: this.state.comments,
      };
    }

    apiPost({
      url: API_URL.user.SendEmailNotification,
      postBody: postBody,
    }).then((response) => {
      if (!response.success) {
        ShowToast(
          "Server Error: Unable to send Application Access email.",
          toastType.ERROR,
          5000,
          500
        );
      } else {
        this.setState({
          comments:""
        });
        ShowToast(
          "Application Access Email has been sent successfully.",
          toastType.SUCCESS,
          5000,
          200
        );
      }
    });
  };
  
  changeComments = (key, value) => {
    this.setState({
      [key]: value,
    });
  };
  
  render() {
    const defaultRoute = IsSectionVisible(SECTIONS.DASHBOARD) ? "/Dashboard" : "/welcome";
    const {
      errorCode,
      heading,
      message,
      goToHomeEnabled,
      comments,
    } = this.state;

    return (
      <div id={"notfound"}>
        <div
          className={this.state.isUnauthorized ? "unauthorized" : "notfound"}
        >
          {this.state.isUnauthorized ? (
            <div>
              <h1>{errorCode}</h1>
              <h2>{heading}</h2>
              <p>{message}</p>
              <TextField
                value={comments}
                onChange={(e) =>
                  this.changeComments("comments", e.target.value)}
                style={{ width: "73%" }}
                placeholder={"Add comments"}
              />
              <Button
                autoFocus
                onClick={() => this.sendInvitationEmail()}
                variant={"contained"}
              >
                {"Request Access\r"}
              </Button>
            </div>
          ) : (
            <>
              <div className={"notfound-404"}>
                <FaBuilding size={"140px"} width={"5em"} />
              </div>
              <h1>{errorCode}</h1>
              <h2>{heading}</h2>
              <p>{message}</p>
              {goToHomeEnabled && errorCode == 401 ? (
                <NavLink
                  to={defaultRoute}
                  onClick={() => {
                    authContext.logOut();
                  }}
                >
                  {" "}
                  <a
                    href={"#"}
                    onClick={() => {
                      authContext.logOut();
                    }}
                  >
                    {"Sign In\r"}
                  </a>
                </NavLink>
              ) : (
                <NavLink to={defaultRoute}>
                  <a href={"#"}>{"Back to homepage"}</a>
                </NavLink>
              )}
            </>
          )}
        </div>
      </div>
    );
  }
}
